var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border bg-white"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.extraData",modifiers:{"extraData":true}}],staticClass:"m-1"},[_vm._v("Add Extra")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"extraData"}},[_c('b-card',{attrs:{"no-body":""}},[(_vm.open)?_vm._t("default"):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8b0af8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_eng/globals/dcard.vue
// module id = 1784
// module chunks = 186